module.exports = __webpack_public_path__ + "img/celular.b5584021.png";